import React from 'react'
import DriverVehicle from '../DriverComponents/DriverVehicle/DriverVehicle'

const DriverVehiclePage = () => {
  return (
    <>
    <DriverVehicle/>
    </>
  )
}

export default DriverVehiclePage